import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { LogoBar } from './components/LogoBar';
import { Features } from './components/Features';
import { Stats } from './components/Stats';
import { HowItWorks } from './components/HowItWorks';
import { Frameworks } from './components/Frameworks';
import { Personas } from './components/Personas';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { TrustStrip } from './components/TrustStrip';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-teal-100 selection:text-teal-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Features data-id="element-4" />
        {/* <Testimonials /> */}
        <HowItWorks data-id="element-5" />
        <Stats data-id="element-6" />
        <Frameworks data-id="element-7" />
        <Personas data-id="element-8" />
        <Pricing data-id="element-9" />
        <FAQ data-id="element-10" />
        {/* <TrustStrip /> */}
        <CTASection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}